module.exports = __webpack_public_path__ + "img/shield-security.3634820c.svg";